import { Component, input } from '@angular/core';

@Component({
  selector: 'field-error',
  imports: [],
  templateUrl: './field-error.component.html',
  styleUrl: './field-error.component.scss'
})
export class FieldErrorComponent {
 
  message = input.required<string>()
  show = input<boolean | undefined>(false)
}
